import AdminLayout from '@/layouts/AdminLayout.vue'

export default [
  {
    path: '/guarantees/create',
    name: 'guaranteeCreate',
    component: () =>
      import(
        '@/views/restricted/manufacturers/category/sub-category/guarantee/GuaranteeCreateView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_PRODUCT_CREATE_PERMISSION'],
      menuSelected: 'manufacturers'
    }
  },
  {
    path: '/guarantees/:guaranteeId/edit',
    name: 'guaranteeUpdate',
    component: () =>
      import(
        '@/views/restricted/manufacturers/category/sub-category/guarantee/GuaranteeUpdateView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_PRODUCT_UPDATE_PERMISSION'],
      menuSelected: 'manufacturers'
    }
  }
]
